import React, { memo, useState, useEffect } from "react";
import { Booking } from "../../../models/booking";
import "../../../../styles/commonStyle.css"
import { getCarModelByName } from '../../../services/carModelService';
import { CarModel } from "../../../models/CarModel"

interface BookingCommunicationDetailsProps {
  booking: Booking;
}

const BookingCabDetails: React.FC<BookingCommunicationDetailsProps> = ({ booking }) => {
  const [carModel, setCarModel] = useState<CarModel>()

  const getCarModel = async () => {
    const model = await getCarModelByName(booking.selectedCarModel)
    if (model)
      setCarModel(model)

  }

  useEffect(() => {
    getCarModel()
  }, [])

  const getCarImage = (carModel: string) => {
    switch (carModel) {
      case "BYD E6":
        return "../images/carImages/byde6.jpg";
      case "BYD eMAX7":
        return "../../../images/carImages/BYDeMAX7.jpg";
      case "MG ZS":
        return "../../../images/carImages/MGZS.jpg";
      case "MG Windsor":
        return "../images/carImages/mgwindsor.jpeg";
      case "Tata Curvv":
        return "../../../images/carImages/TataCurvv.png";
      default:
      // return require("../../../images/carImages/default.jpg"); // Default image
    }
  }



  return (
    <div className="bg-white border rounded shadow-sm p-4 text-start"
      style={{ fontFamily: 'Segoe UI, sans-serif', }}
    >
      <div className="fw-bold mb-3" style={{ fontSize: '1.1rem', color: '#2c3e50' }}>
        Cab Details
     </div>

      <div className="row g-3 align-items-start">
        {/* Car Image */}
        <div className="col-3 col-sm-2">
          <img
            src={getCarImage(booking.selectedCarModel)}
            alt="Car"
            className="img-fluid"
            style={{ maxHeight: '100px', objectFit: 'cover', }}
          />
        </div>

        {/* Car Details */}
        <div className="col-9 col-sm-10">
          <div className="row gx-2 gy-1">
            {/* Car Model */}
            <div className="col-6 col-md-6">
              <small className="fw-bold d-block">Car Model</small>
              <span className="small">{carModel?.carModel}</span>
            </div>

            {/* Car Type */}
            <div className="col-6 col-md-6">
              <small className="fw-bold d-block">Car Type</small>
              <span className="small">{carModel?.carType}</span>
            </div>

            {/* Passenger Capacity */}
            <div className="col-6 col-md-6">
              <small className="fw-bold d-block">Passenger Capacity</small>
              <span className="small">{carModel?.passengerCapacity} + 1 Driver</span>
            </div>

            {/* Luggage Capacity */}
            <div className="col-6 col-md-6">
              <small className="fw-bold d-block">Luggage Capacity</small>
              <span className="small">{carModel?.luggageCapacity}</span>
            </div>
          </div>
        </div>
      </div>




    </div>

  );
};

export default memo(BookingCabDetails);
